/** @file The Weights panel's only links to E8: the document view and the dispatch of one batch. */
import type { CommandCall } from '@pose2d/format/types';
import { dispatch } from '../../api/sync/dispatch';
import { currentDoc } from '../../stores/currentDoc';

/** Read and write path of the panel (E8-R3, E8-R5); one batch = one commit = one undo step. */
export const weightsIo = {
  /** The document panels show: confirmed plus the own pending batches (`useStore(docStore, weightsIo.doc)`). */
  doc: currentDoc,
  /** Dispatches `calls`; rejects with the Pose2DError of a local or server refusal. */
  commit(calls: readonly CommandCall[]): Promise<unknown> {
    return new Promise((resolve, reject) => {
      dispatch([...calls]).done.then(resolve, reject);
    });
  },
};
